var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-list',{attrs:{"list":_vm.list,"columns":_vm.columns,"group-actions":_vm.groupActions,"single-actions":_vm.singleActions,"hide-rowselect":_vm.$store.getters.isProjectMode}})
}
var staticRenderFns = []

export { render, staticRenderFns }